import {
  StationTutorGameItemNo,
  StationItem,
  Rarity,
  StationSeriesNo,
} from './gameStation';

import Path_Station_TutorGame_0001 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0001.png';
import Path_Station_TutorGame_0002 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0002.png';
import Path_Station_TutorGame_0003 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0003.png';
import Path_Station_TutorGame_0004 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0004.png';
import Path_Station_TutorGame_0005 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0005.png';
import Path_Station_TutorGame_0006 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0006.png';
import Path_Station_TutorGame_0007 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0007.png';
import Path_Station_TutorGame_0008 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0008.png';
import Path_Station_TutorGame_0009 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0009.png';
import Path_Station_TutorGame_0010 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0010.png';
import Path_Station_TutorGame_0011 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0011.png';
import Path_Station_TutorGame_0012 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0012.png';
import Path_Station_TutorGame_0013 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0013.png';
import Path_Station_TutorGame_0014 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0014.png';
import Path_Station_TutorGame_0015 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0015.png';
import Path_Station_TutorGame_0016 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0016.png';
import Path_Station_TutorGame_0017 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0017.png';
import Path_Station_TutorGame_0018 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0018.png';
import Path_Station_TutorGame_0019 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0019.png';
import Path_Station_TutorGame_0020 from '../../assets/graphics/png/collections/station_items/path_station_tutorGame_0020.png';

export const STATION_TUTORS = Object.freeze<StationItem[]>([
  {
    itemId: StationTutorGameItemNo.s1,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: true,
    visual: {
      filePrefix: Path_Station_TutorGame_0001,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Default',
    value: 20,
    rarity: Rarity.N,
    seriesId: StationSeriesNo.s1,
  },
  {
    itemId: StationTutorGameItemNo.s2,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: true,
    visual: {
      filePrefix: Path_Station_TutorGame_0002,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Default',
    value: 25,
    rarity: Rarity.N,
    seriesId: StationSeriesNo.s2,
  },
  {
    itemId: StationTutorGameItemNo.s3,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: true,
    visual: {
      filePrefix: Path_Station_TutorGame_0003,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Default',
    value: 39,
    rarity: Rarity.N,
    seriesId: StationSeriesNo.s3,
  },
  {
    itemId: StationTutorGameItemNo.s4,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: true,
    visual: {
      filePrefix: Path_Station_TutorGame_0004,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Default',
    value: 21,
    rarity: Rarity.N,
    seriesId: StationSeriesNo.s4,
  },
  {
    itemId: StationTutorGameItemNo.s5,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: true,
    visual: {
      filePrefix: Path_Station_TutorGame_0005,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Default',
    value: 27,
    rarity: Rarity.N,
    seriesId: StationSeriesNo.s5,
  },
  {
    itemId: StationTutorGameItemNo.s6,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0006,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 23,
    rarity: Rarity.N,
    seriesId: StationSeriesNo.s6,
  },
  {
    itemId: StationTutorGameItemNo.s7,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0007,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 63,
    rarity: Rarity.R,
    seriesId: StationSeriesNo.s7,
  },
  {
    itemId: StationTutorGameItemNo.s8,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0008,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 66,
    rarity: Rarity.R,
    seriesId: StationSeriesNo.s8,
  },
  {
    itemId: StationTutorGameItemNo.s9,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0009,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 88,
    rarity: Rarity.R,
    seriesId: StationSeriesNo.s9,
  },
  {
    itemId: StationTutorGameItemNo.s10,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0010,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 79,
    rarity: Rarity.R,
    seriesId: StationSeriesNo.s10,
  },
  {
    itemId: StationTutorGameItemNo.s11,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0011,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 145,
    rarity: Rarity.SR,
    seriesId: StationSeriesNo.s11,
  },
  {
    itemId: StationTutorGameItemNo.s12,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0012,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 146,
    rarity: Rarity.SR,
    seriesId: StationSeriesNo.s12,
  },
  {
    itemId: StationTutorGameItemNo.s13,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0013,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 184,
    rarity: Rarity.SSR,
    seriesId: StationSeriesNo.s13,
  },
  {
    itemId: StationTutorGameItemNo.s14,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0014,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 263,
    rarity: Rarity.UR,
    seriesId: StationSeriesNo.s14,
  },
  {
    itemId: StationTutorGameItemNo.s15,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0015,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 38,
    rarity: Rarity.N,
    seriesId: StationSeriesNo.s15,
  },
  {
    itemId: StationTutorGameItemNo.s16,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0016,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 43,
    rarity: Rarity.N,
    seriesId: StationSeriesNo.s16,
  },
  {
    itemId: StationTutorGameItemNo.s17,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0017,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 44,
    rarity: Rarity.N,
    seriesId: StationSeriesNo.s17,
  },
  {
    itemId: StationTutorGameItemNo.s18,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0018,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 62,
    rarity: Rarity.R,
    seriesId: StationSeriesNo.s18,
  },
  {
    itemId: StationTutorGameItemNo.s19,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0019,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 71,
    rarity: Rarity.R,
    seriesId: StationSeriesNo.s19,
  },
  {
    itemId: StationTutorGameItemNo.s20,
    category: 'stationItems',
    subcategory: 'assistedGames',
    type: 'stationAssistedGame',
    set: 'regular',
    isVisible: false,
    visual: {
      filePrefix: Path_Station_TutorGame_0020,
      frameCount: 1,
    },
    index: 1,
    rewardSource: 'Pay to Draw',
    value: 131,
    rarity: Rarity.SR,
    seriesId: StationSeriesNo.s20,
  },
]);
